import Immutable from 'immutable';

const initialLoadingState = Immutable.Map({
    loading: false
});

const messageLoader = (state = initialLoadingState, action) => {
    switch (action.type) {
        case 'ADD_MESSAGE':
        case 'TRIGGER_MESSAGE_LOADER':
            return state.set("loading", true);
        case 'ADD_RESPONSE':
            return state.set("loading", false);
        case 'LAST_MESSAGE_ERROR':
            if (action.error) {
                state = state.set("loading", false);
            }
            return state;
        default:
            return state;
    }
}

export default messageLoader;


// WEBPACK FOOTER //
// ./src/reducers/message-loader.js